import * as React from "react";
import "./Toast.component.css";
import { useEffect, useRef, useState } from "react";
import { MessageService } from "../../services/message.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export function Toast() {
    const [toasts, setToasts] = useState([]);
    const timeouts = useRef(new Map());
    const toastsRef = useRef([]);
    useEffect(() => {
        toastsRef.current = toasts;
    }, [toasts]);
    const removeToast = (id) => {
        setToasts(prev => prev.filter(t => t.id !== id));
        const tm = timeouts.current.get(id);
        if (tm !== undefined) {
            clearTimeout(tm);
            timeouts.current.delete(id);
        }
    };
    const closeToast = (id) => {
        setToasts(prev => prev.map(t => t.id === id ? Object.assign(Object.assign({}, t), { closing: true }) : t));
        // Remove after CSS transition (~300ms). Keep in sync with CSS durations.
        window.setTimeout(() => { removeToast(id); }, 320);
    };
    const showToast = (message, severity, timeToShowInMs = 3000, color, messageID) => {
        // close toasts with the same messageID as this message
        if (messageID !== undefined) {
            const existing = toastsRef.current.find(t => t.messageID === messageID);
            if (existing !== undefined)
                closeToast(existing.id);
        }
        const id = Date.now() + Math.random();
        const entry = {
            id,
            message,
            severity,
            duration: timeToShowInMs,
            open: false,
            closing: false,
            color,
            messageID,
        };
        setToasts(prev => [...prev, entry]);
        // trigger enter transition next frame
        requestAnimationFrame(() => {
            setToasts(prev => prev.map(t => t.id === id ? Object.assign(Object.assign({}, t), { open: true }) : t));
        });
        const tm = window.setTimeout(() => { closeToast(id); }, timeToShowInMs);
        timeouts.current.set(id, tm);
    };
    useEffect(() => {
        MessageService.registerGlobalShowToastFn(showToast);
        return () => {
            timeouts.current.forEach(clearTimeout);
            timeouts.current.clear();
        };
    }, []);
    return (React.createElement("div", { className: "toast-stack" }, toasts.map(toast => {
        const stateClass = toast.closing ? "toast--closing" : (toast.open ? "toast--open" : "");
        return (React.createElement("div", { key: toast.id, className: `toast-container ${stateClass}` },
            React.createElement(FontAwesomeIcon, { icon: ["fas", MessageService.getMessageIconName(toast.severity)], size: "2x", className: `${toast.severity}-color` }),
            React.createElement("span", null, toast.message),
            React.createElement("button", { className: "icon-button", onClick: () => { closeToast(toast.id); } },
                React.createElement(FontAwesomeIcon, { icon: ["fas", "times"], size: "1x", className: "toast-close-icon" }))));
    })));
}
